/* eslint-env browser */
import React from 'react';
import ReactDOM from 'react-dom';
import UniverseContainerComponent from '../components/universe/UniverseContainerComponent';

ReactDOM.render(
  <UniverseContainerComponent />,
  document.querySelector('.universeheader'),
);
